import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import { FileCheck, Shield, Clock, Award } from 'lucide-react';
import { Check } from 'lucide-react';

export default function CopyrightRegistration({ onOpenPopup }) {
  const benefits = [
    { icon: <Shield className="h-6 w-6" />, title: 'Legal Protection', description: 'Protect your original creative works from unauthorized use' },
    { icon: <Award className="h-6 w-6" />, title: 'Proof of Ownership', description: 'Establish clear ownership records with the U.S. Copyright Office' },
    { icon: <FileCheck className="h-6 w-6" />, title: 'Litigation Rights', description: 'Ability to sue for infringement in federal court' },
    { icon: <Clock className="h-6 w-6" />, title: 'Quick Processing', description: 'Fast filing and registration process' },
  ];

  const details = [
    { icon: <Check className="h-5 w-5 text-[#E1A334]" />, title: 'Comprehensive Application', description: 'We prepare and file your copyright application with all required documentation and materials.' },
    { icon: <Check className="h-5 w-5 text-[#E1A334]" />, title: 'Expert Review', description: 'Our team reviews your work to ensure proper classification and maximize protection.' },
    { icon: <Check className="h-5 w-5 text-[#E1A334]" />, title: 'Registration Certificate', description: 'Receive your official copyright registration certificate from the U.S. Copyright Office.' },
    { icon: <Check className="h-5 w-5 text-[#E1A334]" />, title: 'Ongoing Support', description: 'Get continued support for renewals and any questions about your copyright.' },
  ];

  const faqs = [
    { question: 'What types of works can be copyrighted?', answer: 'Literary works, musical compositions, dramatic works, choreography, visual arts, motion pictures, sound recordings, and architectural works can all be copyrighted.' },
    { question: 'How long does copyright protection last?', answer: 'For works created after 1978, copyright generally lasts for the life of the author plus 70 years.' },
    { question: 'Do I need to register my copyright?', answer: 'While copyright exists automatically upon creation, registration provides significant legal benefits including the ability to sue for infringement.' },
  ];

  return (
    <ServiceTemplate
      title="Copyright Registration"
      subtitle="Creative Work Protection"
      description="Secure legal protection for your original creative works including literature, music, art, and more. Our comprehensive copyright registration services ensure your intellectual property is properly protected."
      heroImage="/assets/img/copyright.webp"
      infoImage="https://images.unsplash.com/photo-1521791055366-0d553872125f"
      benefits={benefits}
      details={details}
      faqs={faqs}
      onOpenPopup={onOpenPopup}
      testId="copyright-registration-page"
      metaTitle="Copyright Registration Services - Protect Your Creative Works | Trademark Law Consulting"
      metaDescription="Register your copyright with the U.S. Copyright Office. Professional copyright protection for books, music, art, software, and more. Expert filing and ongoing support. Protect your intellectual property today."
    />
  );
}
